export const iconFontAwesomeHumanitarianTowerBroadcast = (
	<i className="fa-solid fa-tower-broadcast"></i>
);
